import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { FamilleData } from "../../models/models";
import { GeneriqueDataType } from "../../constants/enums";
import FamilleTreeView from "./FamilleTreeView";

interface FamilleTreeDialogProps {
  open: boolean;
  onClose: () => void;
  type: GeneriqueDataType;
  onSelect: (famille: FamilleData) => void;
  selectedId?: number | null;
  excludeId?: number;
  title?: string;
}

// Sélection d'une famille en parcourant toute l'arborescence (ouvert depuis FamilleAutoC).
const FamilleTreeDialog: React.FC<FamilleTreeDialogProps> = ({
  open,
  onClose,
  type,
  onSelect,
  selectedId,
  excludeId,
  title = "Arborescence",
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, pr: 6 }}>
      <Box
        sx={{
          width: 32, height: 32, borderRadius: 2, bgcolor: "#eef4ff", color: "#2563eb",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}
      >
        <AccountTreeIcon fontSize="small" />
      </Box>
      <Box>
        <Typography fontWeight={700} color="#101828">{title}</Typography>
        <Typography variant="caption" color="#667085">Cliquez sur un élément pour le sélectionner</Typography>
      </Box>
      <IconButton onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      {open && (
        <FamilleTreeView
          type={type}
          selectedId={selectedId}
          excludeId={excludeId}
          maxHeight="60vh"
          onSelect={(f) => {
            onSelect(f);
            onClose();
          }}
        />
      )}
    </DialogContent>
  </Dialog>
);

export default FamilleTreeDialog;
